import React, { useEffect, useState } from "react";
import Datatable from "core/pagination/datatable";
import { Link } from "react-router-dom";
import { Edit, PlusCircle } from "react-feather";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ClaimTypeForm from "Components/Modal/claim-type";
import { FormProvider, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import {
  useGetClaimTypesQuery,
  useInsertClaimTypeMutation,
  useUpdateClaimTypeMutation,
} from "AppQuries/claim/claim-type";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import { useTableSearch } from "core/Operations/useTableSearch";
import { format } from "date-fns";
import ToastNotification from "Components/UI/ToastNotification";
import TableTop from "Components/UI/TableTop";
import { toast } from "core/Operations/toast";
import { hasPermission } from "core/Operations/checkPermission";
import { Switch } from "antd";
import ReportTools from "Components/UI/ReportTools";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";
const ClaimTypeManagement = () => {
  const userData = useSelector(loggedInUser);
  const [showActiveOnly, setShowActiveOnly] = useState(true);
  const [isMount, setIsMount] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const methods = useForm();
  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch: getClaimTypes,
  } = useGetClaimTypesQuery(
    {
      companyCode: userData?.companyCode,
      isTrue: showActiveOnly,
    },
    {
      enabled: !!userData.companyCode,
    }
  );

  const { mutate: addClaimType } = useInsertClaimTypeMutation();
  const { mutate: updateClaimType } = useUpdateClaimTypeMutation();

  const [selectedClaimType, setSelectedClaimType] = useState(null);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const claimTypeData = Array.isArray(data)
    ? data?.map((d, _id) => ({
        id: _id + 1,
        ...d,
      }))
    : [];

  const handleAddClick = () => {
    setSelectedClaimType(null);
    methods.reset({
      code: 0,
      description: "",
      isActive: true,
      companyCode: userData.companyCode,
      createUser: userData.userName,
      modifyUser: userData.userName,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const handleEditClick = (claimType) => {
    setSelectedClaimType(claimType);
    methods.reset({
      code: claimType.code,
      description: claimType.description,
      isActive: claimType.isActive,
      companyCode: claimType.companyCode,
      createUser: claimType.createUser,
      modifyUser: userData.userName,
      createDate: claimType.createDate,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const onSubmit = async (payload) => {
    console.log(payload);
    if (selectedClaimType) {
      updateClaimType(payload, {
        onSuccess: (data) => {
          if (data?.[0].response) {
            toast.success("Claim Type Updated Successfully.");

            setSelectedClaimType(null);
            setShow(false);
            getClaimTypes();
          } else {
            toast.warning(data?.[0].errorMessage || "Something went wrong.");
          }
        },
        onError: (error) => {
          toast.error(error.message || "Something went wrong.");
        },
      });
    } else {
      addClaimType(payload, {
        onSuccess: (data) => {
          if (data?.[0].response) {
            toast.success("Claim Type Added Successfully.");
            setShow(false);
            getClaimTypes();
          } else {
            toast.warning(data?.[0].errorMessage || "Something went wrong.");
          }
        },
        onError: (error) => {
          toast.error(error.message || "Something went wrong.");
        },
      });
    }
  };

  const columns = [
    {
      title: "SNO",
      dataIndex: "id",
      sorter: (a, b) => a.id.length - b.id.length,
    },

    {
      title: "Description",
      dataIndex: "description",
      sorter: (a, b) => a.description.length - b.description.length,
    },

    {
      title: "Create User",
      dataIndex: "createUser",
      sorter: (a, b) => a.createUser.length - b.createUser.length,
    },

    {
      title: "Status",
      dataIndex: "isActive",
      render: (text, record) => (
        <>
          {text === true && (
            <div className="badges badge-linesuccess">Active</div>
          )}
          {text === false && (
            <div className="badges badge-linedanger">In Active</div>
          )}
        </>
      ),
    },
    {
      title: "Action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <Can accessModule={accessCodes.claim_processing} accessCode={accessCodes.claim_categories} accessType="haveEdit">
            <Link
              className="me-2 p-2"
              to="#"
              onClick={() => handleEditClick(record)}
            >
              <Edit className="feather-edit" />
            </Link>
          </Can>
          {/* <Can accessModule={accessCodes.claim_processing} accessCode={accessCodes.claim_categories} accessType="haveDelete">
            <Link className="confirm-text" to="#" onClick={confirmText}>
              <img src={DeleteIcon} alt="img" />
            </Link>
            </Can> */}
        </div>
      ),
    },
  ];
  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    claimTypeData,
    searchColumns
  );

  useEffect(() => {
    if (isMount) getClaimTypes();

    setIsMount(true);
  }, [showActiveOnly]);

  if (isLoading || isFetching) return <LoadingSpinner />;
  if (isError) return <Error404 error={error} />;

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Claim Types</h4>
                <h6>Manage your claim types</h6>
              </div>
            </div>
            <ReportTools
              columns={columns}
              data={filteredData}
              fileName={`Claim Type Master`}
              pdfTheme="striped"
              refresh={getClaimTypes}
            />
           
              <div className="page-btn">
                <Can accessModule={accessCodes.claim_processing} accessCode={accessCodes.claim_categories} accessType="haveAdd">
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="add-new-tooltip">Add Claim Type</Tooltip>
                  }
                >
                  <Link
                    to="#"
                    className="btn btn-added"
                    onClick={handleAddClick}
                  >
                    <PlusCircle className="me-2" />
                    Add Claim Type
                  </Link>
                </OverlayTrigger>
                </Can>
              </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card table-list-card border-0">
                <div className="card-body">
                  <TableTop
                    onSearch={setSearchValue}
                    toggleFilterVisibility={toggleFilterVisibility}
                    isFilterVisible={isFilterVisible}
                    showToggle={true}
                  />
                  <div
                    className={`card${isFilterVisible ? " visible" : ""}`}
                    id="filter_inputs"
                    // style={{ display: isFilterVisible ? "block" : "none" }}
                  >
                    
                    <div className="card-body pb-0">
                      <div className="form-row row">
                        <div className="row">
                          <div className="col-lg-3 col-sm-6 col-12 mb-3">
                            <div className="form-group">
                              <Switch
                                checked={showActiveOnly}
                                checkedChildren="Show Active"
                                unCheckedChildren="Show All"
                                onChange={(checked) =>
                                  setShowActiveOnly(checked)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <Datatable
                      className="table datanew"
                      columns={columns}
                      dataSource={filteredData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <FormProvider {...methods}>
            <ClaimTypeForm
              mode={selectedClaimType ? "E" : "I"}
              onSubmit={onSubmit}
              show={show}
              handleClose={handleClose}
            />
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default ClaimTypeManagement;
